var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEntityManagementPlugin = function SvgEntityManagementPlugin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC5FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,5.4c0.1-0.1,0.1-0.4,0-0.5s-0.4-0.1-0.5,0L0.3,7.3c-0.4,0.4-0.4,1,0,1.4l2.5,2.5c0.1,0.1,0.2,0.1,0.3,0.1 s0.2,0,0.3-0.1c0.1-0.1,0.1-0.4,0-0.5L0.8,8.2c-0.1-0.1-0.1-0.3,0-0.4L3.3,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,7.3l-2.5-2.5c-0.1-0.1-0.4-0.1-0.5,0s-0.1,0.4,0,0.5l2.5,2.5c0.1,0.1,0.1,0.3,0,0.4l-2.5,2.5 c-0.1,0.1-0.1,0.4,0,0.5c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1l2.5-2.5C16.1,8.3,16.1,7.7,15.7,7.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 8,
    r: 0.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEntityManagementPlugin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/entity_management_plugin.264e54a032c92e44ca1c75613c411f82.svg";